import { Outlet } from "react-router-dom";

const ConciergeOutlet = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ConciergeOutlet;
